import { createClient } from '@supabase/supabase-js';
import React, { useRef } from 'react';
import root from 'react-shadow/styled-components';
import { Provider as SupabaseProvider } from 'react-supabase';
import { Provider as OrgProvider } from '../../context/org';
import { Provider as UserProvider } from '../../context/user';
import Questions from '../Questions';
import { Theme } from '../Theme';
export var Squeak = function Squeak(_ref) {
  var apiKey = _ref.apiKey,
      url = _ref.url,
      apiHost = _ref.apiHost,
      organizationId = _ref.organizationId,
      slug = _ref.slug;
  var supabase = createClient(url, apiKey);
  var containerRef = useRef();
  return /*#__PURE__*/React.createElement(root.div, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(SupabaseProvider, {
    value: supabase
  }, /*#__PURE__*/React.createElement(OrgProvider, {
    value: {
      organizationId: organizationId,
      apiHost: apiHost
    }
  }, /*#__PURE__*/React.createElement(UserProvider, null, /*#__PURE__*/React.createElement(Theme, {
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "squeak"
  }, /*#__PURE__*/React.createElement(Questions, {
    slug: slug
  }))))));
};